export default "__VITE_ASSET__60bb259d__"